<template>
  <div class="allsize">
    <img src="static/szjc.png" alt="">
  </div>
</template>
<script>
import '../assets/rem'
// 导入接口：

export default {
  
}
</script>

<style lang="scss" scoped>
.allsize{
  img{
    width:100%;
    max-width: 1920px;
  }
}
</style>
